import { ModelSagresDatatable } from "@/types/model-sagres-datatable";
import { ParticipanteLicitacao } from "./participante-licitacao";

export class VencedorItem extends ModelSagresDatatable {
  IdItemLicitacao: number;
  IdLicitacao: number;

  Vencedor: string;
  QtLicitada: number;
  VlUnitarioEstimado: number;
  NmMarcaItemMatServ: string;
  VlUnitarioLicitado: number;
  DtHomologacaoItem: Date;

  VlTotalEstimado: number;
  VlTotalLicitado: number;
  IdParticipanteLicitacao: number;
  IdParticipanteItemLicitacao: number;

  VlTotalLicitadoItem: number;

  //transients / not mapped
  modoEdicao = false;
  novoValorUnit: number;
  novaQtde: number;
  novaMarca: string;
  novaDtHomologacaoItem: Date;
  loading = false;

  /**
   * Construtor com instância original de VencedorItem, para clonar IDs.
   * @param original Irei buscar os IDs do original para poder fazer o update
   */
  constructor(original?: VencedorItem) {
    super();
    if (original) {
      this.IdItemLicitacao = original.IdItemLicitacao;
      this.IdParticipanteLicitacao = original.IdParticipanteLicitacao;
      this.IdParticipanteItemLicitacao = original.IdParticipanteItemLicitacao;
    }
  }

  //TO-DO: Centralizar estes tratamentos no ModelSagres. Dá pra loopar o obj e tratar todas as datas.
  //também dá pra criar enums para estas strings sim/nao, ativo/inativo etc
  tratarDadosDaAPI(): void {
    if (this.DtHomologacaoItem) {
      this.DtHomologacaoItem = new Date(this.DtHomologacaoItem);
    }
  }

  /**
   * Este método deveria ser um construtor ou então um tratarDadosDaAPI. Precisamos decidir como fica mais limpo e onde mais esta classe é utilizada.
   * @param pi ParticipanteItem, porém não tipado.
   *
   * @since 20230831
   */
  inicializarRetorno(pi: any): void {
    this.IdItemLicitacao = pi.IdItemLicitacao;
    this.IdLicitacao = pi.IdLicitacao;
    this.Vencedor = pi.NmParticipante;
    this.QtLicitada = pi.QtItem;
    this.VlUnitarioEstimado = pi.VlUnitarioEstimado;
    this.NmMarcaItemMatServ = pi.NmMarcaItemMatServ;
    this.VlUnitarioLicitado = pi.VlUnitarioLicitado;
    if (pi.DtHomologacaoItem)
      this.DtHomologacaoItem = new Date(pi.DtHomologacaoItem);
    this.IdParticipanteLicitacao = pi.IdParticipanteLicitacao;
    this.IdParticipanteItemLicitacao = pi.IdParticipanteItemLicitacao;
    this.VlTotalLicitadoItem = pi.VlTotalLicitadoItem;
  }

  /* isVencedorPreenchido(): boolean {
    return this.IdParticipanteLicitacao !== null && this.IdParticipanteLicitacao !== undefined
  } */

  isQuantidadeLicitadaPreenchida(): boolean {
    return (
      this.novaQtde !== null && this.novaQtde !== undefined && this.novaQtde > 0
    );
  }

  isValorUntarioLicitadoPreenchido(): boolean {
    return (
      this.novoValorUnit !== null &&
      this.novoValorUnit !== undefined &&
      this.novoValorUnit > 0
    );
  }

  isMarcaPreenchida(): boolean {
    return (
      this.novaMarca !== null &&
      this.novaMarca !== undefined &&
      this.novaMarca !== ""
    );
  }

  isDataHomologacaoPreenchida(): boolean {
    return (
      this.novaDtHomologacaoItem !== null &&
      this.novaDtHomologacaoItem !== undefined
    );
  }

  isPreenchido(validarDataHomologacao: boolean) {
    const isDadosVencedorValidos =
      this.isQuantidadeLicitadaPreenchida() &&
      this.isValorUntarioLicitadoPreenchido();
    return validarDataHomologacao
      ? isDadosVencedorValidos && this.isDataHomologacaoPreenchida()
      : isDadosVencedorValidos;
  }
}
